import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't refetch just because the user switched browser tabs and came
      // back — for Discover this reshuffled the randomly-sampled feed and made
      // it feel jittery. Mutations (favorite/dismiss) still invalidate
      // explicitly, so data stays correct after user actions.
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // Treat data as fresh for 5 minutes so in-app navigation back to a tab
      // doesn't trigger a background refetch-and-swap.
      staleTime: 5 * 60 * 1000,
    },
  },
});
